"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var levelMapper = { 1: 'body1', 2: 'body2', caption: 'caption' };
// const StyledTypography = styled(Typography)(({ color }) => ({ color: !color ? 'inherit' : undefined }));
//
// const Text: React.FC<Props> = React.forwardRef(
//   ({ level, ...rest }, ref) => <StyledTypography variant={level && levelMapper[level]} ref={ref} {...rest} />,
// );
var Text = react_1.default.forwardRef(function (_a, ref) {
    var level = _a.level, rest = __rest(_a, ["level"]);
    return (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: level && levelMapper[level], ref: ref }, rest));
});
exports.default = Text;
